import { RootState } from '@app/model';

export const selectAuthError = ({ auth: { authError } }: RootState) => authError;
export const selectLoading = ({ auth: { authIsLoading } }: RootState) => authIsLoading;
